import axios from 'axios';
import { useAppNavigate } from '../../Context/NavigateContext';
import { URL_MIDIS, URL_AUTH, URLAPI } from '../../Setting';

// Fonction de navigation injectee depuis React (via NavigateProvider).
// Valeur inerte par defaut tant que initAxiosWithNavigation n'a pas ete appele.
let navigateFunction: (path: string) => void = () => {};

// Fonction pour initialiser Axios avec la navigation
export function initAxiosWithNavigation(navigate: (path: string) => void) {
  navigateFunction = navigate;
}

// Purge le cookie token. Le path DOIT correspondre a celui de la pose (Login : path:'/').
function purgeToken() {
  document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
}

// Intercepteur de reponse pour gerer les erreurs 401
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const url: string = error.config?.url ?? '';
    // Le POST d'authentification renvoie legitimement un 401 (mauvais mot de passe) :
    // il est gere par LoginService, on ne redirige donc pas dans ce cas.
    const estAppelAuth = url.includes(URL_AUTH);

    console.log('axiosConfig - Intercepteur Axios - ', error.response?.status);

    if (error.response?.status === 401 && !estAppelAuth) {
      purgeToken();
      console.log('Redirection vers /login...');
      navigateFunction('/login'); // Redirige vers /login
    }
    return Promise.reject(error);
  }
);

// Pas d'export d'instance : on configure le axios global.
// L'import de ce fichier (dans index.tsx) suffit a activer l'intercepteur.
export {};
